import React from 'react';
import { FormField, Label } from '@zillow/constellation-10';

import YesAndNo from '../../../Widgets/YesAndNo';

type Props = {
  yesActive: boolean;
  yesHandler: () => void;
  noHandler: () => void;
  dataTest?: string;
  disabled?: boolean;
};

export default function SecurityDepositInterestYesAndNo({ dataTest, disabled, ...rest }: Props) {
  return (
    <FormField
      required
      label={
        <Label>
          Will the security deposit interest be returned to the tenant at the end of the lease (less any deposit
          claims)?
        </Label>
      }
      disabled={disabled ? disabled : false}
      control={<YesAndNo {...rest} disabled={disabled} data-test={dataTest} />}
    />
  );
}
